module.exports = __webpack_public_path__ + "static/media/32.4eff0d18.png";